<script setup>
import {Swipe, SwipeItem} from "vant";
import {getJson} from "@/api/common";
import {onMounted, reactive, ref} from "vue";
import RightLightning from "@/components/NewPC/RightLightning.vue";
import LeftLightning from "@/components/NewPC/LeftLightning.vue";

const PlayerSwipeRef = ref(null);
const featureList = ref([]);
const swipeIndex = ref(0);

const images = reactive({
  wutu_1: require('@/assets/newPc/player/wutu_1.png'),
  wutu_2: require('@/assets/newPc/player/wutu_2.png'),
  wutu_3: require('@/assets/newPc/player/wutu_3.png'),
  wutu_4: require('@/assets/newPc/player/wutu_4.png'),
  wutu_5: require('@/assets/newPc/player/wutu_5.png'),
})

const getImage = (name) => {
  console.log('images[name]:', images[name]);
  return images[name];
}

const swipeChange = index => {
  swipeIndex.value = index;
}
const playerPageChange = (item, type) => {
  if (type == 'next') {
    item.next();
  } else {
    item.prev();
  }
}
const playerSwipeChange = (item, index) => {
  if (index == swipeIndex.value) return;
  item.swipeTo(index)
}

const handleJumpGift = () => {
  const element = document.getElementById('gift');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

onMounted(() => {
  getJson().then(result => {
    if (result.status == 200 && result.data.code == 0) {
      featureList.value = result.data.data.news.feature;
    }
  })
})
</script>

<template>
  <div class="screen">

    <swipe class="screen_swipe" ref="PlayerSwipeRef" :show-indicators="false" @change="swipeChange">
      <swipe-item class="screen_swipe_item" v-for="item of featureList">
        <div class="content">
          <img :src="getImage(item.icon)" alt="">
          <div class="text_block">
            <div>
              <span v-for="txt of item.text">{{txt}}</span>
            </div>
            <div class="pr10">{{item.desc}}</div>
          </div>
        </div>
      </swipe-item>
    </swipe>

    <img class="swipe_left_icon" @click="playerPageChange(PlayerSwipeRef, 'prev')" src="@/assets/newPc/player/swipe_left_icon.png"  alt="">
    <img class="swipe_right_icon" @click="playerPageChange(PlayerSwipeRef, 'next')" src="@/assets/newPc/player/swipe_right_icon.png" alt="">

    <div class="swipe_dots">
      <div class="cover_block" v-for="(item, index) of featureList">
        <img :class="{'active': swipeIndex == index}"  @click="playerSwipeChange(PlayerSwipeRef, index)" :src="getImage(item.icon)" alt="">
      </div>
    </div>

    <div class="tips_block">
      <text>下滑浏览 领福利</text>
      <img src="@/assets/newPc/more_icon_2.png" alt="">
    </div>

<!--    <img class="gift_entry" @click="handleJumpGift" src="@/assets/newPc/gift_entry.png" alt="">-->

    <left-lightning class="left_lightning" />
    <right-lightning class="right_lightning" />
  </div>
</template>

<style scoped lang="scss">
.screen {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(to right , #b5cfff, #e6efff);
  position: relative;

  .swipe_left_icon, .swipe_right_icon {
    width: 3.1640625vw;
    height: 4.8046875vw;
    position: absolute;
    top: 17.3828125vw;
    cursor: pointer;
    z-index: 1;
  }
  .swipe_left_icon {
    left: 18.515625vw;
  }
  .swipe_right_icon {
    right: 18.515625vw;
  }

  .swipe_dots {
    position: absolute;
    top: 35.78125vw;
    left: 0;
    right: 0;
    background-color: transparent;
    z-index: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-left: 3.90625vw;
    box-sizing: border-box;

    .cover_block {
      width: 11.6796875vw;
      height: 6.5234375vw;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 8.0859375vw;
        height: 4.53125vw;
        cursor: pointer;

        &.active {
          width: 11.6796875vw;
          height: 6.5234375vw;
        }
      }
    }
  }

  .screen_swipe {
    width: 100vw;
    height: 100vh;
    position: relative;
    z-index: 1;
    cursor: default;

    .screen_swipe_item {
      width: 100vw;
      height: 27.5390625vw;
      display: flex;
      justify-content: center;
      padding-top: 6.3671875vw;
      box-sizing: border-box;
      cursor: default;
      .content {
        width: 48.9453125vw;
        height: 27.5390625vw;
        position: relative;

        img {
          width: 48.9453125vw;
          height: 27.5390625vw;
        }


        .text_block {
          position: absolute;
          bottom: 0;
          right: 0;
          padding-bottom: 2.6171875vw;
          padding-right: 3.125vw;

          div {
            text-align: right;
            font-size: 0.9375vw;
            color: #FCFCFB;
            font-family: 'SourceHanSansCN-Regular';
            line-height: 1;
            margin-top: 0.9375vw;

            span {
              font-size: 3.90625vw;
              font-family: 'YouSheBiaoTiHei';
              margin-bottom: 0.9375vw;
              line-height: 1;
              &:nth-child(even) {
                color: #FFEF32;
              }
            }
          }
        }
      }


    }
  }

  .gift_entry {
    position: absolute;
    top: 29.5703125vw;
    right: 1.640625vw;
    z-index: 1;
    width: 9.0625vw;
    height: 6.171875vw;
    cursor: pointer;
  }

  .tips_block {
    position: absolute;
    top: 42.734375vw;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #4C6ACB;
    font-size: 0.9375vw;
    font-family: 'SourceHanSansCN-Medium';

    img {
      width: 2.6171875vw;
      height: 2.109375vw;
    }
  }

  .pr10 {
    padding-right: 0.390625vw;
  }

  .left_lightning {
    position: absolute;
    left: 0;
    top: 28.59375vw;
  }

  .right_lightning {
    position: absolute;
    right: 0;
    top: 8.671875vw;
  }

}
</style>